import { hotEvents } from '@/mocks/gua';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line',
  flat: 'ri-arrow-right-up-line',
  down: 'ri-arrow-down-line',
};
const trendColor: Record<string, string> = {
  up: 'text-primary-600',
  flat: 'text-accent-700',
  down: 'text-secondary-600',
};

function SectionHead({ id, kicker, title, sub }: { id: string; kicker: string; title: string; sub?: string }) {
  return (
    <div id={id} className="scroll-mt-24 flex flex-col gap-1.5">
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">{kicker}</span>
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{title}</h2>
      {sub && <p className="mt-1 max-w-2xl text-sm text-foreground-700">{sub}</p>}
    </div>
  );
}

export default function HotSection() {
  return (
    <section className="container-x py-12 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionHead
          id="hot"
          kicker="今日热搜榜"
          title="今天瓜田里，大家都在吃啥"
          sub="按全网讨论热度实时整理，标记每个瓜当前所处的阶段，方便你按热度挑着看。"
        />
        <a
          href="#timeline"
          className="inline-flex whitespace-nowrap items-center gap-1 rounded-md bg-secondary-100 px-4 py-2 text-sm text-secondary-900 transition-colors hover:bg-secondary-200"
        >
          全部时间线
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {hotEvents.map((e) => (
          <article
            key={e.id}
            className="group flex items-start gap-4 rounded-lg bg-background-100 p-4 transition-colors hover:bg-background-200/70"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-50 font-heading text-lg font-bold text-secondary-800">
              {e.rank}
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-950">
                <a href="#timeline" className="transition-colors group-hover:text-primary-700">
                  {e.title}
                </a>
              </h3>
              <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-accent-900">
                  {e.tag}
                </span>
                <span className="inline-flex items-center gap-1 text-secondary-700">
                  <i className="ri-fire-line text-primary-600" aria-hidden="true"></i>
                  {e.heat}
                </span>
                <span className={`inline-flex items-center ${trendColor[e.trend]}`}>
                  <i className={trendIcon[e.trend]} aria-hidden="true"></i>
                </span>
                <span className="text-secondary-600">{e.time}</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}